import { useSelector, useDispatch } from "react-redux";
import { setResultsForLayer } from "../../../../redux/resultsSlice";
import GroupPopup from "../GroupPopup";

const ResultsLayers = () => {
    // State to pass to child component when a layer/feature is clicked
    const dispatch = useDispatch();
    const layers = useSelector((state) => state.resultsData.results);

    // Get total to display on title
    let total = 0;
    layers.forEach((layer) => {
        if (!layer.Features) {
            total = total + 1;
        } else {
            total = total + layer.Features.length;
        }
    });

    const handleClick = (layer) => {
        dispatch(setResultsForLayer([layer]));
    };

    return (
        <div id="results-layers">
            <div className="results-title">Identify Results ({total})</div>
            <div className="results-options">
                <GroupPopup results={layers} icon={"menu"} />
            </div>
            {layers.map((layer) => {
                return (
                    <li key={layer.Id} className="feature-row">
                        <div
                            key={layer.DisplayName}
                            className="results-feature feature-label"
                            onClick={() => handleClick(layer)}>
                            {layer.DisplayName} ({layer.Features.length})
                        </div>
                        <GroupPopup results={[layer]} icon={"elipsis"} />
                    </li>
                );
            })}
        </div>
    );
};

export default ResultsLayers;

// When features from multiple layers are selected
// Example of input:
/*
[
    {
        "DisplayName": "Subdivision",
        "FeatureLabel": "{LayerDisplayName}",
        "FeatureDescription": "{SUBNAME}",
        "Id": "7b4yxl",
        "Features": [
            "507",
            "509"
        ]
    },
    {
        "DisplayName": "Parcel",
        "FeatureLabel": "{LayerDisplayName}",
        "FeatureDescription": "{PrimaryNameOne}<br/>{PropertyAddress}",
        "Id": "MbNYA6",
        "Features": [
            "3378",
            "3227",
            "138"
        ]
    }
]

*/
